import './textarea.scss'
import classNames from 'classnames'

export default function Textarea({ label, ...inputProps }) {
    const [value, setValue] = React.useState(inputProps.value || '')

    const onInputChange = e => {
        setValue(e.target.value)
        inputProps.onChange && inputProps.onChange(e)
    }

    const className = classNames('textarea', {
        'is-active': value,
    })

    return (
        <div className={className}>
            <textarea {...inputProps} rows="5" className="textarea__input" onChange={onInputChange} />
            <label className="textarea__label">{label}</label>
        </div>
    )
}
